import { Avatar, AvatarGroup, Flex } from '@chakra-ui/react'
import { CheckboxCmp } from '../../../../../components/CheckboxCmp'
import { iRespostaQuestao } from '../../../../../interfaces'

interface iProps {
  questao: iRespostaQuestao
}

export const QuestaoCaixaSelecao: React.FC<iProps> = ({ questao }) => {
  return (
    <Flex flexDir={'column'} gap={'.5rem'}>
      {
        questao.alternativaResposta?.map((r, i2) => {
          return (
            <Flex gap={'.75rem'} alignItems='center'>
              <AvatarGroup>
                {r.avatares.map(avatar => {
                  return <Avatar src={avatar} size={'xs'}/>
                })}
              </AvatarGroup>
              <Flex padding={'.75rem 1rem'} borderRadius={'.25rem'} border={'1px solid var(--c6)'} bg={'var(--AzulOpacoBg)'} fontWeight={700} gap={'.25rem'} w={'100%'}>
                <CheckboxCmp isChecked OnChange={() => {}}></CheckboxCmp>
                <span>{r.resposta}</span>
              </Flex>
            </Flex>
          )
        })
      }
    </Flex>
  )
}
